import {differenceInCalendarDays, parse} from 'date-fns';
import {DateFormatEnum} from 'presentation/constants/dateFormatEnum';

export const isAppointmentPastDue = (dateString: string): boolean => {
	const parsedAppointmentDate = parse(dateString, DateFormatEnum.DATE_FORMAT_1, new Date());

	const daysFromAppointmentDate = differenceInCalendarDays(parsedAppointmentDate, new Date());
	return daysFromAppointmentDate < 0;
};
